import React from 'react'

import { pathUrl } from 'src/variable/constant'

import AuthenLayout from 'src/layouts/AuthenLayout'
import DefaultLayout from 'src/layouts/DefaultLayout'
import CategoryTrailsPage from 'src/pages/CategoryTrailsPage'
import CategoryTrailsDetailPage from 'src/pages/CategoryTrailsPage/[id]'
import ConfigPhonePage from 'src/pages/ConfigPhonePage'
import ConversationPage from 'src/pages/ConversationPage'
import GuidersPage from 'src/pages/GuidersPage'
import GuiderDetailPage from 'src/pages/GuidersPage/[id]'
import Home from 'src/pages/Home'
import LoginPage from 'src/pages/LoginPage'
import NetworkPage from 'src/pages/NetworkPage'
import NotFound from 'src/pages/NotFound'
import NotificationPage from 'src/pages/NotificationPage'
import OtpTrackingPage from 'src/pages/OtpTrackingPage'
import ProvincePage from 'src/pages/Province'
import SettingsPage from 'src/pages/SettingsPage'
import SettingDetailPage from 'src/pages/SettingsPage/[id]'
import TermsAndPolicy from 'src/pages/TermsAndPolicy'
import TopicsPage from 'src/pages/TopicsPage'
import SubTopicsPage from 'src/pages/TopicsPage/[id]/SubTopicsPage'
import UsersPage from 'src/pages/UsersPage'
import UserDetailPage from 'src/pages/UsersPage/[id]'
import EventsPage from 'src/pages/EventsPage'
import BooksPage from 'src/pages/BooksPage'
import EmployeesPage from 'src/pages/EmployeePage/EmployeesPage'
import EmployeeDetailPage from 'src/pages/EmployeePage/[id]/EmployeeDetailPage'
import MyProfilePage from 'src/pages/MyProfilePage'
import UserCountryPage from 'src/pages/Country'
import StickerPage from 'src/pages/StickerPage'
import BannerPage from 'src/pages/BannerPage'
import CacheConfigPage from 'src/pages/CacheConfigPage'
import GoogleApiStatsPage from 'src/pages/GoogleApiStatsPage'
import CountryDetailPage from 'src/pages/Country/[name]/CountryDetailPage'
import ProvinceDetailPage from 'src/pages/Province/[name]/ProvinceDetailPage'
import LocationUsersPage from 'src/pages/LocationUsersPage'
import VersionStatsPage from 'src/pages/VersionStatsPage'
import CommunityStatsPage from 'src/pages/CommunityStatsPage'
import ChangelogPage from 'src/pages/ChangelogPage'
import BlockPage from 'src/pages/BlockPage'
import BooksUniViniPage from 'src/pages/BooksUniViniPage'
import ListYourBizPage from 'src/pages/ListYourBizPage'
import FindMyGuidePage from 'src/pages/FindMyGuidePage'
import FindMyTutorPage from 'src/pages/FindMyTutorPage'
import CourseAiPage from 'src/pages/CourseAiPage'
import ScriptRunPage from 'src/pages/ScriptRunPage'
import ReportPage from 'src/pages/ReportPage'
import DatabaseStoragePage from 'src/pages/DatabaseStoragePage'
import BadwordPage from 'src/pages/BadwordPage'
import ActiveUsersPage from 'src/pages/ActiveUsersPage'
import SupportInboxPage from 'src/pages/SupportInboxPage'
import RedeemRequestsPage from 'src/pages/RedeemRequestsPage'

const publicRoute = [
	// {
	// 	path: '/',
	// 	component: Home,
	// 	layout: DefaultLayout,
	// },
	// landing-page
	// {
	// 	path: '/',
	// 	component: LandingPage,
	// 	layout: React.Fragment,
	// },

	{
		path: pathUrl.home,
		component: Home,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.province,
		component: ProvincePage,
		layout: DefaultLayout,
	},
	{
		path: '/province/:name',
		component: ProvinceDetailPage,
		layout: DefaultLayout,
	},
	{
		path: '/province/:name/users',
		component: LocationUsersPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.country,
		component: UserCountryPage,
		layout: DefaultLayout,
	},
	{
		path: '/country/:name',
		component: CountryDetailPage,
		layout: DefaultLayout,
	},
	{
		path: '/country/:name/users',
		component: LocationUsersPage,
		layout: DefaultLayout,
	},
	{
		path: '/users',
		component: UsersPage,
		layout: DefaultLayout,
	},
	{
		path: '/users/:id',
		component: UserDetailPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.activeUsers,
		component: ActiveUsersPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.redeemRequests,
		component: RedeemRequestsPage,
		layout: DefaultLayout,
	},
	{
		path: '/guiders',
		component: GuidersPage,
		layout: DefaultLayout,
	},
	{
		path: '/guiders/:id',
		component: GuiderDetailPage,
		layout: DefaultLayout,
	},
	{
		path: '/employees',
		component: EmployeesPage,
		layout: DefaultLayout,
	},
	{
		path: '/employees/:id',
		component: EmployeeDetailPage,
		layout: DefaultLayout,
	},
	// {
	// 	path: '/roles',
	// 	component: RolesPage,
	// 	layout: DefaultLayout,
	// },
	{
		path: '/categorytrails',
		component: CategoryTrailsPage,
		layout: DefaultLayout,
	},
	{
		path: '/categorytrails/:id',
		component: CategoryTrailsDetailPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.topics,
		component: TopicsPage,
		layout: DefaultLayout,
	},
	{
		path: `${pathUrl.topics}/:id`,
		component: SubTopicsPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.configphone,
		component: ConfigPhonePage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.otpTracking,
		component: OtpTrackingPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.notification,
		component: NotificationPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.supportInbox,
		component: SupportInboxPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.changelog,
		component: ChangelogPage,
		layout: DefaultLayout,
	},
	// {
	// 	path: pathUrl.service,
	// 	component: ServicePage,
	// 	layout: DefaultLayout,
	// },
	{
		path: pathUrl.conversation,
		component: ConversationPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.network,
		component: NetworkPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.event,
		component: EventsPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.book,
		component: BooksPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.bookUniVini,
		component: BooksUniViniPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.listYourBiz,
		component: ListYourBizPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.findMyGuide,
		component: FindMyGuidePage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.findMyTutor,
		component: FindMyTutorPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.courseAi,
		component: CourseAiPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.sticker,
		component: StickerPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.banner,
		component: BannerPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.cacheConfig,
		component: CacheConfigPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.googleApiStats,
		component: GoogleApiStatsPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.versionStats,
		component: VersionStatsPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.communityStats,
		component: CommunityStatsPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.block,
		component: BlockPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.report,
		component: ReportPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.badword,
		component: BadwordPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.scriptRun,
		component: ScriptRunPage,
		layout: DefaultLayout,
	},
	{
		path: pathUrl.databaseStorage,
		component: DatabaseStoragePage,
		layout: DefaultLayout,
	},
	{
		path: '/settings',
		component: SettingsPage,
		layout: DefaultLayout,
	},
	{
		path: '/settings/:id',
		component: SettingDetailPage,
		layout: DefaultLayout,
	},
	{
		path: '/my-profile',
		component: MyProfilePage,
		layout: DefaultLayout,
	},
	//policy
	{
		path: '/terms',
		component: TermsAndPolicy,
		layout: React.Fragment,
	},
	//policy
	{
		path: '/policy',
		component: TermsAndPolicy,
		layout: React.Fragment,
	},
	// login
	{
		path: '/login',
		component: LoginPage,
		layout: AuthenLayout,
	},
	{ path: '*', component: NotFound, layout: DefaultLayout },
]
const privateRoute = [] // sau nafy co be tinh tiep

export { privateRoute, publicRoute }
